"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var NotValid = /** @class */ (function (_super) {
    __extends(NotValid, _super);
    function NotValid(_a) {
        var message = _a.message, status = _a.status;
        var _this = _super.call(this, "An error occurred while fetching the data.") || this;
        _this.message = message !== null && message !== void 0 ? message : "";
        _this.status = status;
        return _this;
    }
    return NotValid;
}(Error));
function Fetcher(_a) {
    var _this = this;
    var _b;
    if (_a === void 0) { _a = {}; }
    var extended = _a.extended, validateStatus = _a.validateStatus, params = __rest(_a, ["extended", "validateStatus"]);
    var encoding = (_b = params === null || params === void 0 ? void 0 : params.encoding) !== null && _b !== void 0 ? _b : "json";
    var headers = __assign(__assign({}, params === null || params === void 0 ? void 0 : params.headers), (encoding === "json" && {
        "Content-Type": "application/json",
    }));
    var formatBody = function (data) {
        if ((params === null || params === void 0 ? void 0 : params.encoding) === "form") {
            var formData_1 = new FormData();
            if (data && typeof data === "object") {
                Object.keys(data).forEach(function (key) {
                    formData_1.append(key, data[key]);
                });
            }
            return formData_1;
        }
        if ((params === null || params === void 0 ? void 0 : params.encoding) === "url") {
            var searchParams_1 = new URLSearchParams();
            if (data && typeof data === "object") {
                Object.keys(data).forEach(function (key) {
                    searchParams_1.set(key, String(data[key]));
                });
            }
            return searchParams_1;
        }
        return JSON.stringify(data);
    };
    var options = function (method, data) { return (__assign(__assign({}, params), { method: method, headers: headers, credentials: params === null || params === void 0 ? void 0 : params.credentials, mode: params === null || params === void 0 ? void 0 : params.mode, body: data ? formatBody(data) : undefined, signal: params === null || params === void 0 ? void 0 : params.signal })); };
    var handleResponse = function (response) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!response) return [3 /*break*/, 6];
                    if (!(typeof validateStatus === "function")) return [3 /*break*/, 2];
                    if (!!validateStatus(response.status)) return [3 /*break*/, 2];
                    _a = NotValid.bind;
                    _c = {};
                    return [4 /*yield*/, response.json().catch(function () { return null; })];
                case 1: throw new (_a.apply(NotValid, [void 0, (_c.message = _e.sent(),
                        _c.status = response.status,
                        _c)]))();
                case 2:
                    if (!extended) return [3 /*break*/, 4];
                    _d = {};
                    return [4 /*yield*/, response.json().catch(function () { return null; })];
                case 3:
                    _b = (_d.data = _e.sent(),
                        _d.status = response.status,
                        _d.headers = response.headers,
                        _d);
                    return [3 /*break*/, 5];
                case 4:
                    _b = response.json().catch(function () { return null; });
                    _e.label = 5;
                case 5: return [2 /*return*/, _b];
                case 6: return [2 /*return*/, extended
                        ? {
                            data: null,
                            status: null,
                        }
                        : null];
            }
        });
    }); };
    return {
        get: function (url) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = handleResponse;
                    return [4 /*yield*/, fetch(url, options("GET"))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        }); }); },
        post: function (url, data) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = handleResponse;
                    return [4 /*yield*/, fetch(url, options("POST", data))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        }); }); },
        put: function (url, data) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = handleResponse;
                    return [4 /*yield*/, fetch(url, options("PUT", data))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        }); }); },
        patch: function (url, data) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = handleResponse;
                    return [4 /*yield*/, fetch(url, options("PATCH", data))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        }); }); },
        delete: function (url) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = handleResponse;
                    return [4 /*yield*/, fetch(url, options("DELETE"))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        }); }); },
    };
}
exports.default = Fetcher;
//# sourceMappingURL=index.js.map